import { createSlice } from "@reduxjs/toolkit";
import {
  onGetCustomerList,
  onAddCustomer,
  onUpdateCustomer,
  onDeleteCustomer,
} from './thunk';

export const initialState = {
  customerList: [],
  errors: {}
};

const CustomersSlice = createSlice({
  name: 'Customers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // List
    builder.addCase(onGetCustomerList.fulfilled, (state: any, action: any) => {
      state.customerList = action.payload;
    });
    builder.addCase(onGetCustomerList.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onAddCustomer.fulfilled, (state: any, action: any) => {
      state.customerList.unshift(action.payload);
    });
    builder.addCase(onAddCustomer.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onUpdateCustomer.fulfilled, (state: any, action: any) => {
      state.customerList = state.customerList.map((list: any) =>
        list.userId === action.payload.userId
          ? { ...list, ...action.payload }
          : list
      );
    });
    builder.addCase(onUpdateCustomer.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onDeleteCustomer.fulfilled, (state: any, action: any) => {
      state.customerList = state.customerList.map((list: any) =>
        list.userId === action.payload.userId
          ? { ...list, ...action.payload }
          : list
      );
    });
    builder.addCase(onDeleteCustomer.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
  }
});

export default CustomersSlice.reducer;